module.exports = __webpack_public_path__ + "img/ketang.574c5bbe.png";